module.exports = __webpack_public_path__ + "static/media/free_tools_2.ad2f5bf5.png";